import { reactive, useRoute } from "#imports";
import { productStore as useProductStore } from "#sitis/stores/modules/product-store";
import { storeToRefs } from "pinia";
export default function useProduct(config) {
  const route = useRoute();
  const slug = route?.params?.slug || "";
  const productStore = useProductStore();
  const {
    getRelatedProductsInState,
    getRecentlyProductsInState,
    getSameProductsInState
  } = storeToRefs(productStore);
  const state = reactive({
    product: {},
    productBreadcrumbs: [],
    getProductsSame: [],
    isLoadProductsSame: false,
    productsRecently: [],
    isLoadProductsRecently: false,
    productsRelated: [],
    isLoadProductsRelated: false
    // deliveries: [],
    // modifications: [],
    // modificationVariants: [],
    //
    // productSetChildren: [],
    // productSetChildrenCharacteristicGroups: [],
  });
  const getProduct = async (extensions) => {
    const res = await productStore.getProduct({
      slug: String(slug),
      extensions
    }).catch(() => null);
    if (res === null) {
      return void 0;
    }
    state.product = res;
    state.productBreadcrumbs = productStore.breadcrumbs;
    return res;
  };
  const getProductsSame = async (extensions) => {
    state.isLoadProductsSame = true;
    await productStore.getSameProducts({ slug: String(slug), extensions });
    state.productsSame = getSameProductsInState.value;
    state.isLoadProductsSame = false;
    return state.productsSame;
  };
  const getProductsRecently = async (extensions) => {
    state.isLoadProductsRecently = true;
    await productStore.getRecentlyProducts({ slug: String(slug), extensions });
    state.productsRecently = getRecentlyProductsInState.value;
    state.isLoadProductsRecently = false;
    return state.productsRecently;
  };
  const getProductsRelated = async (extensions) => {
    state.isLoadProductsRelated = true;
    await productStore.getRelatedProducts({ slug: String(slug), extensions });
    state.productsRelated = getRelatedProductsInState.value;
    state.isLoadProductsRelated = false;
    return state.productsRelated;
  };
  return {
    state,
    getProductsRelated,
    getProduct,
    getProductsSame,
    getProductsRecently
  };
}
